/*
 * @Author: Merlin
 * @Date: 2025-06-23 13:33:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-25 14:46:46
 * @Description: 
 * 
 * 
 * 在这里搜索到的 redPacketMines 需要逐步替换 
 */

import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import type { Player, Seat } from './types.d';
import useSettingsStore from '@/stores/settings';

// 拿取各个厅的封面图
export const fnGetCoverPics = () => {
    const oPics = import.meta.glob('../img/hall-cover/*.webp', {
        eager: true,
    });

    const aList = Object.entries(oPics).map(([key, value]) => {
        const sLongName = key.split('/').pop();
        const iPointIdx = sLongName.lastIndexOf('.');
        return [
            sLongName.slice(0, iPointIdx),
            (value as { default: any }).default,
        ];
    });

    const oResult = Object.fromEntries(aList);
    return oResult;
};

// ↓ 跳转到游戏入口页 
export const fnGoToEntrance = (
    oConfig={},
)=>{
    const path = `/casino/zhajinhuaGame/entrance`; 
    useRouter().replace({
        path: getLocalPath(path),
        ...oConfig,
    });
}

export const goHome = () => {
    useRouter().replace({
        path: getLocalPath('/'),
    });
};

// ↓ 大厅列表 
export const getHallsList = ()=>{
    if (import.meta.server) return []; 
    const joinStateStore = useJoinStateStore();  
    const userStore = useUserStore();
    const oNowCurrency = userStore.oNowCurrency; 
    const {t: $tFn} = useNuxtApp().$i18n;
    const { hallLimit, halls } = (joinStateStore as any)?.zhajinhuaGame || {};
    // ↓ 防止报错 
    if (!halls) return [];
    const oHallsCurrentLimit = hallLimit?.[oNowCurrency.currencyName];
    const settingStore = useSettingsStore();
    const balance = Number(
        userStore.freezes.find(
            (it) =>
                it.game === 'zhajinhua' &&
                it.coin_type.toLowerCase() === settingStore.pickedCurrency,
        )?.coin_cnt || 0,
    );
    const aOrder = ["trial", "casual", "premium", "rick", "vip"];

    const aResult = Object.values(halls).flatMap((oHall: any) => {
        const hallCurrentLimit = oHallsCurrentLimit?.[oHall.name];
        if (!hallCurrentLimit) {
            console.error(oHall.name, '配置信息缺失');
            return []; // 跳过
        }
        return [
            {
                intOrder: aOrder.indexOf(oHall.name) + 1, // 1-5
                ...oHall,
                ...hallCurrentLimit,
                // ↓ 计算余额是否足够进入游戏
                accessable: balance >= Number(hallCurrentLimit.minimumEntry),
                // ↓ 计算是否余额足够下注
                betable: balance >= Number(hallCurrentLimit.minBet),
            },
        ];
    });
    aResult.sort((aa, bb)=>{
        const v01 = aa.intOrder;
        const v02 = bb.intOrder;
        return v01 - v02; // 升序 
    });
    return aResult;
}

export const initSeats = (): Seat[] => {
    return Array(5)
        .fill(1)
        .map((_, idx) => ({
            occupied: false,
            player_id: 0,
            position: idx,
        }));
};

/**
 * 获取下一位玩家
 * 
 * @param arrangedPlayers 已经排好相对位置的玩家数组
 * @param currentId 当前玩家的 id
 * @returns 下一位玩家对象
 */
export function getNextPlayer<T extends { id: number }>(
    arrangedPlayers: T[],
    currentId: number
): T | null {
    const index = arrangedPlayers.findIndex(p => p.id === currentId);
    if (index === -1) return null;

    const nextIndex = (index + 1) % arrangedPlayers.length;
    return arrangedPlayers[nextIndex];
}

/**
 * 旋转玩家数组，确保自己（isSelf=true）永远在数组最后一个位置
 * 其他玩家的顺序保持不变
 */
export function rotateAndMapPlayers(players: Player[]): Player[] {
    const selfIndex = players.findIndex(p => p?.isSelf);
    if (selfIndex === -1) return players;

    // 旋转数组，让自己在最后
    const rotated = players.slice(selfIndex + 1).concat(players.slice(0, selfIndex + 1));

    // 映射关系数组（原始索引 -> 目标索引）
    // 0 -> 2, 1 -> 1, 2 -> 3, 3 -> 0, 4 -> 4
    const map = [2, 1, 3, 0, 4];

    // 根据映射生成新数组
    return map.map(i => rotated[i]);
}

export function findLastInGamePlayer(players: Player[], firstPlayerId: number): Player | null {
    const total = players.length;

    const firstIndex = players.findIndex(p => p?.id === firstPlayerId);
    if (firstIndex === -1) return null;

    // 从 firstIndex 前一位开始找
    let idx = (firstIndex + total - 1) % total;

    for (let i = 0; i < total; i++) {
        const p = players[idx];
        if (p?.inGame) {
            return p;
        }
        idx = (idx + total - 1) % total; // 环形向前找
    }

    return null;
}

// TODO: 测试代码，后期删除
export function getTwoRandomIndexesNonEmpty(arr) {
    // 获取非空元素下标
    const validIndexes = arr
        .map((val, idx) => (!!val.id ? idx : null))
        .filter((idx) => idx !== null);

    if (validIndexes.length < 2) {
        throw new Error('非空元素不足两个');
    }

    // 随机抽两个下标
    const first = validIndexes.splice(Math.floor(Math.random() * validIndexes.length), 1)[0] + 1;
    const second = validIndexes[Math.floor(Math.random() * validIndexes.length)] + 1;

    return [first, second];
}
